<template>
  <div class="row justify-content-center">
    <div class="col-12 col-md-10 col-sm-12 col-xs-12">
      <UsuarioList />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import UsuarioList from "../../../../_shared/features/UsuarioList.vue";

export default {
  name: "UsuariosSite",
  components: { UsuarioList },
  data() {
    return {};
  },
  methods: {},
};
</script>
